/**
 * @author - Steves165
 */

(function() {
    'use strict';

    /**
     * List of supported social network sharing links.
     */
    var socialNetworks = {
        facebook: 'http://www.facebook.com/sharer/sharer.php?s=100&p[url]=',
        twitter: 'https://twitter.com/intent/tweet?text=',
        gplus: 'https://plus.google.com/share?url=',
        pinterest: '//www.pinterest.com/pin/create/button/?description='
    };

    function sanitizeHtml(html) {
        var cleaned = '';
        if (!/script/.test(html) || !/<style/.test(html)) {
            cleaned = html;
        } else {
            cleaned = html.replace(/<script>[\s\S]*?<\/script>/, '').replace(/<style>[\s\S]*?<\/style>/, '');
        }

        return cleaned;
    }

    angular.module('socialSharing', [])

    /**
     * Builds a social sharing link for Facebook, Twitter, Pinterest and Google plus.
     *
     * @return - directive Object
     */
        .directive('socialShare', function() {
            return {
                replace: true,
                scope: {
                    shareSentence: '@',
                    currDestination: '@',
                    shareLink: '@',
                    imageLink: '@',
                    socialNetwork: '@',
                    pinImage: '@'
                },
                link: function($scope, $element) {
                    if (!$scope.shareLink || $scope.shareLink === '') {
                        $scope.shareLink = encodeURIComponent(location.href);
                    }

                    var shareContent = '';

                    if ($scope.socialNetwork === 'twitter' || $scope.socialNetwork === 'pinterest') {
                        if ($scope.shareSentence && $scope.shareSentence !== '') {
                            shareContent = $scope.shareSentence.replace('**destination**', $scope.currDestination).replace('#', encodeURIComponent('#')).replace('**url**', location.href) + '&media=' + location.protocol + '//' + location.host + $scope.pinImage;
                        } else {
                            shareContent = '&media=' + location.protocol + '//' + location.host + $scope.pinImage;
                        }
                    } else {
                        shareContent = $scope.shareLink;
                    }

                    $scope.href = socialNetworks[$scope.socialNetwork] + shareContent;

                    if (!$scope.imageLink || (/.imaging\/Desktop\/dam\/$/.test($scope.imageLink) || /^$|\s+/.test($scope.imageLink))) {
                        $element.parent().addClass('mode-icons');
                        $scope.logoTag = '<i class="social-share-icon icon-' + $scope.socialNetwork + '"/>';
                    } else {
                        $scope.logoTag = '<img class="social-share-icon" src="' + $scope.imageLink + '"/>';
                    }

                    /**
                     * Opens the link in a new window 640pxx300px
                     *
                     * @returns {boolean}
                     */
                    $scope.popupWindow = function() {
                        return !window.open($scope.href, $scope.socialNetwork, 'width=640,height=300');
                    };
                },
                template: '<a id="qa-{{socialNetwork}}-share" class="{{socialNetwork}}-share" target="_blank" ng-click="popupWindow()" data-pin-shape="round" data-pin-height="20" data-pin-do="buttonBookmark"><span ng-bind-html="logoTag | to_trusted"></span></a>'
            };
        })

        .directive('emailPage', ["$window", function($window) {
            return {
                restrict: "E",
                scope: {
                    subject: "@",
                    body: "@"
                },
                replace: true,
                transclude: true,
                link: function($scope, $element, $attrs) {
                    $scope.subject = $scope.subject || "You have been sent a link to Virgin Holidays";
                    $scope.body = $scope.body || "Hi,%0A%0AYou have been sent a page by Virgin Holidays.%0A%0A" + escape($window.location.href);
                },
                template: '<a href="mailto:?subject={{subject}}&body={{body}}" class="email-link qa-email-link"><i class="social-share-icon icon-envelope"></i></a>'
            };
        }])

        .filter('to_trusted', ['$sce', function($sce){
            return function(text) {
                var cleaned = sanitizeHtml(text);
                return $sce.trustAsHtml(cleaned);
            };
        }]);

})();
